import { API_URL } from './api/apiDictionary';

export type API_URL_KEYS_TYPE = keyof typeof API_URL;
export type API_URL_VALUES_TYPE = (typeof API_URL)[API_URL_KEYS_TYPE];

export type ActiveMocks = typeof activeMocks;

export const activeMocks: Partial<Record<API_URL_VALUES_TYPE, boolean>> = {
  [API_URL.readerTask]: false,
};
